import * as React from 'react';

declare interface HamburgerProps extends React.HTMLAttributes<HTMLButtonElement> {
  isMenuOpen?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
}

function Hamburger({ isMenuOpen, ref, ...props }: HamburgerProps) {
  return (
    <button
      className={`group size-full border-l border-l-gray-300 p-8 transition-all ease-in-out ${
        isMenuOpen ? 'bg-primary' : 'hover:bg-gray-100'
      }`}
      ref={ref}
      {...props}
    >
      <span className="hamburger hamburger--squeeze relative">
        <span className="hamburger-box absolute right-[15px] top-3">
          <span
            className={`hamburger-inner rounded-[3px] content-['_'] ${isMenuOpen ? '0-h bg-white group-hover:bg-grey-100' : 'h-0.5 bg-black'}
              absolute bottom-2.5 left-0 w-[30px] transition-all ease-in-out ${
              isMenuOpen ? 'before:translate-y-2.5 before:rotate-45' : ''
            } before:absolute before:bottom-2.5 before:left-0
              before:h-0.5 before:w-[30px] before:rounded-[3px] before:bg-inherit before:transition-transform before:ease-in-out
              before:content-['_'] ${isMenuOpen ? 'after:-translate-y-3 after:-rotate-45' : ''} after:absolute after:left-0
              after:top-2.5 after:h-0.5 after:w-[30px] after:rounded-[3px] after:bg-inherit after:transition-transform
              after:ease-in-out after:content-['_']`}
          ></span>
        </span>
      </span>
    </button>
  );
}

export { Hamburger };
export type { HamburgerProps };
